export const WHATSAPP_LINK =
  "https://wa.me/5511960640542?text=Ol%C3%A1,%20gostaria%20de%20saber%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20atendimento.";
export const INSTAGRAM_LINK = "https://www.instagram.com/domy.nutri/";
